export default "__VITE_ASSET__87aa70cb__"